import React from "react";
import { Routes, Route, Navigate } from "react-router";
import BlueprintDashboard from "../components/RecipeForm/BlueprintDashboard";
import BlueprintLayout from "../components/RecipeForm/BlueprintLayout";
import PlanGeneration from "../components/PlanComparison/PlanGeneration";
import PlanTracking from "../components/PlanComparison/PlanTracking";
import PlanComparison from "../components/PlanComparison/PlanComparison";

const Blueprint = () => {
  return (
    <Routes>
      <Route path="/" element={<BlueprintDashboard />} />
      <Route path="/:recipeName" element={<BlueprintLayout />} />
      <Route
        path="/:recipeName/generate"
        element={
          <BlueprintLayout>
            <PlanGeneration />
          </BlueprintLayout>
        }
      />
      <Route
        path="/:recipeName/tracking"
        element={
          <BlueprintLayout>
            <PlanTracking />
          </BlueprintLayout>
        }
      />
      <Route
        path="/:recipeName/compare"
        element={
          <BlueprintLayout>
            <PlanComparison />
          </BlueprintLayout>
        }
      />
    </Routes>
  );
};

export default Blueprint;
